import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "formatStatus"
})

export class FormatStatusPipe implements PipeTransform{
    transform(status) {
        if (!status) {
            return ''
        }
        return status.toString().trim().replace(/-/g, ' ');
    }
}
